(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    // Requires a network
    //

  function pxGoPrintersList(
    PrinterListPOSTPaging, PrinterListService, $location, $window, $rootScope, $timeout,
    EventHandlerService, EventServiceEvents, $http, toastr, $filter
  ) {
    return {
      restrict: 'EA',
      scope: {
        goProfile: '=goProfile',
        onDeviceConfig: '=onDeviceConfig',
        tenant: '=tenant',
        me: '=me',
        meta: '=meta',
        callback: '&callback',
      },
      templateUrl: 'app/components/onDeviceConfigProperties/goPrintersList/goPrintersList.template.html',
      link: function(scope) {


        var scrollEnd = null;
        var containerHeight = null;
        var embedPrinterStatus = true;
        scope.loading = true;
        scope.printerPagingObject = new PrinterListPOSTPaging();
        scope.showPrinterWithIssues = false;
        scope.enableOnDevice = scope.tenant.info.enableOnDevice;

        (function() {
          setListeners();
          getFirstPage();
        })();

        scope.$watch(function() {
          return scope.onDeviceConfig
        }, function (oldVal, newVal) {
          if (oldVal !== newVal) {
            scope.onDeviceConfig = scope.onDeviceConfig;
            checkIfUpdateIsRequired(scope.loadedPrinters);
          }
        })

        function getFirstPage () {
          scope.printerPagingObject.pagingCriteria.types = 'NETWORK,VIRTUAL';
          scope.printerPagingObject.pagingCriteria.pageSize = 20;
          scope.printerPagingObject.pagingCriteria.page = 0;
          scope.loading = true;
          scope.loadedPrinters = [];
          scope.onDeviceConfig.getPrinters(scope.printerPagingObject, embedPrinterStatus).then(function(printers) {
            window.scrollTo(0,0);
            scope.totalPages = printers.page.totalPages;
            if (printers.list) {
              var tempPrinters = createTargetUrl(printers.list);
              tempPrinters = addIcon(tempPrinters);
              tempPrinters = checkIfUpdateIsRequired(tempPrinters);
              scope.loadedPrinters = tempPrinters;
            } else {
              scope.loadedPrinters = null;
            }
            scope.loading = false;

          }).catch(function(error) {
            scope.loading = false;
          });
        }

        function getNextPage () {
          if (!scope.loading && scope.totalPages > scope.printerPagingObject.pagingCriteria.page + 1) {
            scope.loading = true;
            scope.printerPagingObject.pagingCriteria.page += 1;
            scope.onDeviceConfig.getPrinters(scope.printerPagingObject, embedPrinterStatus).then(function(printers){
              if (printers.list) {
                var tempPrinters = createTargetUrl(printers.list);
                tempPrinters = addIcon(tempPrinters);
                tempPrinters = checkIfUpdateIsRequired(tempPrinters);
                scope.loadedPrinters = scope.loadedPrinters.concat(tempPrinters);
              }
              scope.loading = false;
            }).catch(function(error){})
          }
        }

        $timeout(function () {
          angular.element('.go-printers-list').on('scroll', function (event) {
            scrollEnd = event.currentTarget.clientHeight + event.currentTarget.scrollTop + 1;
            containerHeight = event.currentTarget.scrollHeight;
            if (!scope.loading && scope.totalPages > scope.printerPagingObject.pagingCriteria.page + 1) {
              if (scrollEnd > containerHeight) {
                $timeout(function() {
                  getNextPage();
                }, 300)
              }
            }
          });
        }, 100)

        function createTargetUrl (printers) {
          var target = $location.absUrl();
          target = target.split('goConfiguration/');
          angular.forEach(printers, function(printer) {
            printer.info.icon = 'icon-printer';
            printer.targetUrl = target[0] + `printerProperties/${printer.customProperties.id}`;
          });
          return printers;
        }

        function addIcon (printers) {
          angular.forEach(printers, function (printer) {
            printer.icon = 'icon-printer';
          })
          return printers;
        }

        function checkIfUpdateIsRequired (tempPrinters) {
          for (var i = 0; i < tempPrinters.length; i++) {
            if (new Date(tempPrinters[i].info.onDeviceInstallTime).getTime() < new Date(scope.onDeviceConfig.info.modified).getTime()) {
              tempPrinters[i].info['updateRequired'] = true;
            } else if (tempPrinters[i].info.onDeviceInstallState === 'UNKNOWN') {
              tempPrinters[i].info['updateRequired'] = true;
            }
          }
          return tempPrinters;
        }

        scope.textSearch = function () {
          scope.printerPagingObject.pagingCriteria.match = scope.searchString;
          scope.list = [];
          $timeout(function () {
            getFirstPage();
          }, 500)
        }

        scope.gotoProperties = function (printer) {
          $window.open(printer.targetUrl, '_blank');
        }

        scope.testGoConfiguration = function (printer) {
          var printerId = printer.info._links.self.href.split('/')
          printerId = printerId[printerId.length - 1];
          var url = printer.info._links['px:testPrinterCredential'].href + '?printerIds=' + printerId;
          $http.post(url).then(function(response) {
            toastr.succes($filter('translate')('OK'))
          }).catch(function(error) {
            toastr.error($filter('translate')('ERROR'))
          });
        }

        function checkIfUpdateIsRequiredInMenu (printer) {
          if (!printer.info.onDeviceInstallTime) {
            return true;
          } else if (new Date(scope.onDeviceConfig.info.modified).getTime() > new Date(printer.info.onDeviceInstallTime).getTime()) {
            return true;
          } else if (printer.info.onDeviceInstallState === 'UNKNOWN') {
            return true;
          }

          return false;
        }

        function checkForValidSignInProfile (printer) {
          if (!printer.info.onDeviceTestState) {
            return true;
          } else if (printer.info.onDeviceTestState === 'UNKNOWN') {
            return true;
          }


          return false;
        }

        ////////////////////////////////////////////
        ////////////////////////////////////////////
        // TOOLTIP STUFF
        ////////////////////////////////////////////
        scope.showTooltip = function (showTip, position, tooltipScope, context) {
          if (showTip) {
            switch(tooltipScope) {
              case 'statement':
                tooltip(position, context);
              break;
              case 'site':
                tooltip(position, context);
              break;
            }
          }
          else {
            scope.clearTooltip();
          }
        }


        function tooltip (position, title) {
          switch (title) {
            case 'INSTALLED':
              title = 'Installed';
            break;
            case 'UNINSTALLED':
              title = 'UnInstalled';
            break;
            case 'FAILED':
              title = 'FAILED';
            break;
            case 'UNKNOWN':
              title = 'Unknown';
            break;
            case 'GoVersionOutdated':
              title = 'GoVersionOutdated';
            break;
          }
          scope.clearTooltip();
          scope.tooltipContent = {
            title: title,
            type: 'statement',
          }
          scope.tooltipObject = {
            position: {left: position.startX, top: position.startY + 20}
          }
        }

        scope.clearTooltip = function () {
          scope.tooltipContent = null;
          scope.tooltipObject = null;
        }

        ////////////////////////////////////////////
        ////////////////////////////////////////////
        // Directly open a contextual popup dialog
        ////////////////////////////////////////////
        scope.openContext = function (event, context, menuOption) {
          scope.closeAllMenues()
          $timeout(function  () {
            scope.selectedContextMenuItem  =  menuOption;
            scope.contextContentPosition = { left: event.clientX, top: event.clientY }
            scope.contextPosition = { left: event.clientX, top: event.clientY }
            scope.contextContent = context;
            scope.context = context;
            scope.auxiliaries = {
              tenant: scope.tenant
            };
          }, 50)
        }

        scope.closeAllMenues = function() {
          scope.menuContent = null;
          scope.menuSpecs = null;
          scope.selectedContextMenuItem = null;
          scope.contextContentPosition = null;
          scope.contextPosition = null;
          scope.contextContent = null;
          scope.context = null;
          scope.auxiliaries = null;
        }

        scope.openGoProfileMenu = function(event, printer) {
          scope.closeAllMenues();
          $timeout(function () {
            scope.menuContent = {
              menuItems: [
                {
                  title: 'AssignSignInProfile', selected: false, type: 'selectSignInProfile', breaker: true, name: printer.info.name,
                  warning: checkForValidSignInProfile(printer), disabled: scope.me.isSystemObserver()
                },
                {
                  title: 'UpdateGoConfiguration', selected: false, type: 'updateDeviceConfigOnPrinter', breaker: true,
                  disabled: enableOnDeviceState() || scope.me.isSystemObserver(), name: printer.info.name,
                  warning: checkIfUpdateIsRequiredInMenu(printer) ? true : false
                },
                {
                  title: 'PrinterProperties', selected: false, type: 'link', breaker: false,
                  href: '/admin/#/printerProperties/' + printer.customProperties.id + '?printerSection=printixGo'
                },
              ],
              context: printer,
              icon: 'icon-printer',
              sizeClass: 'size115',
              type: 'ALLROUND'
            }
            scope.menuContent.context.name = printer.info.name;
            scope.menuSpecs = {
              position: {left: event.clientX, top: event.clientY},
              type: 'ALLROUND'
            }
          }, 50)
        }

        scope.openContextMenu = function (selectedContextMenuItem, contextPosition, menu) {
          scope.closeAllMenues();

          if (selectedContextMenuItem && selectedContextMenuItem.name) {
            selectedContextMenuItem.title = selectedContextMenuItem.name;
          }

          $timeout(function  () {
            scope.selectedContextMenuItem = selectedContextMenuItem;
            scope.contextPosition = contextPosition;
            scope.context =  menu ? menu.context : null;;
            scope.resource = scope.tenant;
            scope.auxiliaries = {
              tenant: scope.tenant,
              printer: menu ? menu.context : null,
              onDeviceConfig: scope.onDeviceConfig
            }
          }, 50)
        }

        function enableOnDeviceState () {
          if (scope.tenant.info.enableOnDevice === 'SUSPENDED') {
            return true;
          }
          return false;
        }

        ////////////////////////////////////////////
        ////////////////////////////////////////////
        // UPDATING PRINTER
        ////////////////////////////////////////////
        function getPrinterByUrl (printerId) {
          PrinterListService.getPrinterByURL(printerId).then(function(printer) {
            for (var i = 0; i < scope.loadedPrinters.length; i++) {
              if (scope.loadedPrinters[i].info._links.self.href === printer.info._links.self.href) {
                getFirstPage();
              }
            }
          }).catch(function(error) {})
        }

        ////////////////////////////////////////////
        ////////////////////////////////////////////
        // EVENTS
        ////////////////////////////////////////////
        function setListeners () {



          scope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_USERS.EVENTS.PRINTER_REMOVED, function(name, data) {
            if (data.network === scope.network._links.self.href) {
              angular.forEach(scope.network.loadedPrinters, function (printer) {
                if (data.printer === printer.info._links.self.href) {
                  getFirstPage();
                }
              })
            }
          });

          scope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_USERS.EVENTS.PRINTER_UPDATE, function(name, data) {
            for (var i = 0; i < scope.loadedPrinters.length; i++) {
              if (data.printer === scope.loadedPrinters[i].info._links.self.href) {
                getPrinterByUrl(data.printer);
                break;
              }
            }
          });

        }

        var REFRESH_GO_PRINTER_LIST = $rootScope.$on('REFRESH_GO_PRINTER_LIST', function(name, data) {
          getFirstPage();
        })

        var REMOVE_GO_FROM_PRINTER = $rootScope.$on('REMOVE_GO_FROM_PRINTER', function(name, data) {
          for (var i = 0; i < scope.loadedPrinters.length; i++) {
            if (data.printer.info._links.self.href === scope.loadedPrinters[i].info._links.self.href) {
              getFirstPage();
            }
          }
        })

        scope.$on('$destroy', function() {
          REFRESH_GO_PRINTER_LIST();
          REMOVE_GO_FROM_PRINTER();
        });


      }
    };
  }

  pxGoPrintersList.$inject = [
    'PrinterListPOSTPaging', 'PrinterListService', '$location', '$window', '$rootScope', '$timeout',
    'EventHandlerService', 'EventServiceEvents', '$http', 'toastr', '$filter'
  ];

  angular
    .module('printix-admin')
    .directive('pxGoPrintersList', pxGoPrintersList);

})();
